import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import http from "../../../utils/http";
import { TableFilterParams } from "../util/types";
import { InviteUserPayload } from "./types";

const BaseURL = process.env.REACT_APP_API_URL;

export const fetchAllUsers = createAsyncThunk(
  "fetch_all_users",
  async (lazyParams: TableFilterParams, { rejectWithValue }) => {
    const { organisationId, page, rows, filters } = lazyParams;
    try {
      const resp = await http.get({
        url: `${BaseURL}/organisation-portal/find-filtered-organisation-b2b-accounts/${organisationId}`,
        query: {
          page,
          rows,
          searchString: filters.global.value,
        },
      });
      return resp;
    } catch (err: any) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const sendInvite = createAsyncThunk(
  "invite_account",
  async (data: InviteUserPayload, { rejectWithValue }) => {
    try {
      const resp = await http.post({
        url: `${BaseURL}/organisation-portal/create-organisation-b2b-account`,
        body: data,
      });
      return resp;
    } catch (err: any) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);
